import { eventEmitter } from "../../services";
import { TYPE_SUCCESS, TYPE_FAILURE, TYPE_INFO, TYPE_WARNING } from "..";
import { AxiosError } from "axios";

export const NOTIFICATION_SET = "notification/set";
export const NOTIFICATION_CLEAR = "notification/clear";

export type NotificationType = "s" | "f" | "i" | "w";
const typeMap: Record<NotificationType, string> = {
    s: TYPE_SUCCESS,
    f: TYPE_FAILURE,
    i: TYPE_INFO,
    w: TYPE_WARNING,
};

export class NotificationService {
    set(messageId: string, type: NotificationType = "i") {
        eventEmitter.emit(NOTIFICATION_SET, {
            messageId,
            type: typeMap[type],
        });
    }

    apiError(e: AxiosError) {
        if (e.response) {
            this.set(e.response.data.errors[0], "f");
        }
    }

    clear() {
        eventEmitter.emit(NOTIFICATION_CLEAR);
    }
}
